var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14162 2.99957C3.6942 2.99957 2.37893 4.29538 2.37893 6.13711V14.6398C2.37893 16.4815 3.6942 17.7773 5.14162 17.7773H18.7176C20.1696 17.7773 21.4571 16.4858 21.3753 14.6878C21.3746 14.6718 21.3742 14.6559 21.3742 14.6398V6.13711C21.3742 4.29538 20.059 2.99957 18.6116 2.99957H5.14162ZM0.267822 6.13711C0.267822 3.31986 2.34655 0.888458 5.14162 0.888458H18.6116C21.4066 0.888458 23.4853 3.31986 23.4853 6.13711V14.6171C23.602 17.4672 21.4999 19.8885 18.7176 19.8885H5.14162C2.34655 19.8885 0.267822 17.4571 0.267822 14.6398V6.13711Z",
    fill: "#4F91FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62715 5.64579C4.91459 5.13861 5.55874 4.96046 6.06592 5.24789L11.0046 8.04675C11.5764 8.35419 12.1812 8.35419 12.753 8.04675L17.6918 5.24789C18.1988 4.96046 18.8431 5.13861 19.1305 5.64579C19.4179 6.15297 19.2397 6.79713 18.7326 7.08456L13.7847 9.88865L13.7678 9.89794C12.5631 10.552 11.1945 10.552 9.98979 9.89794L9.97301 9.88865L5.02505 7.08456C4.51787 6.79713 4.33972 6.15297 4.62715 5.64579Z",
    fill: "#4F91FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.f296b698b05e31e3194ffe4b147e6bcf.svg";
export { ForwardRef as ReactComponent };